export default __webpack_public_path__ + "static/media/Add_new_wine-rounded.d3d568f3.svg";